// extracted by mini-css-extract-plugin
export default {"button":"screenCaptureRecord_button__Bp-Lt"};